module.exports = __webpack_public_path__ + "static/media/house.03e5066b.jpeg";